const desc = `<p>
    על <span class="bold">ביהודה החדשה – האור</span> כ"ט חשון תרע"ב [1911 11 20]
  </p>`;

export default desc;
